@if (usuarioAutenticado) {
    <div
        class="layout-wrapper"
        [ngClass]="{
            'layout-menu-horizontal': menuMode === 'horizontal',
            'layout-menu-popup': menuMode === 'popup',
            'layout-menu-overlay': menuMode === 'overlay',
            'layout-menu-static': menuMode === 'static',
            'layout-menu-static-inactive':
                menuMode == 'static' && menuActive === false,
        }"
        (click)="onLayoutClick()"
    >
        <app-topbar></app-topbar>
        <div class="layout-content">
            <router-outlet class="hidden"></router-outlet>
        </div>
    </div>
}

@if (!usuarioAutenticado) {
    <router-outlet class="hidden"></router-outlet>
}

@if (exibirLoader | async) {
    <div
        style="
            position: fixed;
            width: 100vw;
            height: 100vh;
            top: 0;
            left: 0;
            z-index: 100;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: rgba(255, 255, 255, 0.4);
        "
    >
        <p-progressSpinner></p-progressSpinner>
    </div>
}

@if (exibirLoaderNetwork | async) {
    <div
        style="
            position: fixed;
            width: 100vw;
            height: 100vh;
            top: 0;
            left: 0;
            z-index: 100;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: rgba(255, 255, 255, 0.4);
        "
    >
        <p-progressSpinner></p-progressSpinner>
    </div>
}

<p-toast position="bottom-right"></p-toast>

<!--<app-alterar-senha [modalVisible]="modalAlterarSenhaVisible" (closeModal)="modalAlterarSenhaVisible = false"></app-alterar-senha>-->
